/**
 * Formatea un monto como precio en RD$
 * @param {number} amount
 * @param {{ decimals?: number, currency?: string }} options
 */
export function formatPrice(amount, { decimals = 2, currency = 'RD$' } = {}) {
  return `${currency} ${Number(amount || 0).toLocaleString('es-DO', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
}

/**
 * Formatea un Firestore Timestamp o Date como fecha legible
 * @param {import('firebase/firestore').Timestamp|Date|string|null} ts
 * @param {Intl.DateTimeFormatOptions} options
 */
export function formatDate(ts, options = { day: 'numeric', month: 'short', year: 'numeric' }) {
  const date = ts?.toDate?.() ?? (ts instanceof Date ? ts : ts ? new Date(ts) : null);
  if (!date || isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('es-DO', options);
}

/**
 * Devuelve tiempo relativo: "ahora", "5m", "3h", "2d", o fecha corta
 * @param {import('firebase/firestore').Timestamp|Date|null} ts
 */
export function timeAgo(ts) {
  const date = ts?.toDate?.() ?? (ts instanceof Date ? ts : null);
  if (!date) return '';
  const diff = (Date.now() - date.getTime()) / 1000;
  if (diff < 60)     return 'ahora';
  if (diff < 3600)   return `${Math.floor(diff / 60)}m`;
  if (diff < 86400)  return `${Math.floor(diff / 3600)}h`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d`;
  return date.toLocaleDateString('es-DO', { day: 'numeric', month: 'short' });
}
